import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import withStyles from "@material-ui/core/styles/withStyles";
import Toolbar from "@material-ui/core/Toolbar";
import MoreVertIcon from "@material-ui/icons/MoreVertOutlined";
import React, { MouseEvent } from "react";
import { DataTableProps, styles } from "./commons";
import { List } from "@material-ui/core";
import ListSubheader from "@material-ui/core/ListSubheader";

class DataTableToolbarComponent extends React.Component<DataTableProps> {
  public state = {
    anchorEl: null
  };

  public handle = (event: MouseEvent<HTMLButtonElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  public handleClose = () => {
    this.setState({ anchorEl: null });
  };

  public render() {
    const { anchorEl } = this.state;
    const { classes, disableCheckboxes, selected } = this.props;
    const open = Boolean(anchorEl);

    if (disableCheckboxes === false) {
      return <></>;
    }

    return (
      <Toolbar className={classes.toolbar}>
        {this.props.toolbarButtons && (
          <>
            <IconButton
              aria-label="More"
              aria-haspopup="true"
              style={{ display: "inline-block" }}
              onClick={this.handle}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={this.handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left"
              }}
              getContentAnchorEl={null}
            >
              <List
                component="nav"
                subheader={
                  <ListSubheader component="div" id="nested-list-subheader">
                    {"Rows selected: " + selected.length}
                  </ListSubheader>
                }
              >
                {this.props.toolbarButtons(this.handleClose)}
              </List>
            </Menu>
          </>
        )}
      </Toolbar>
    );
  }
}

export const DataTableToolbar = withStyles(styles)(DataTableToolbarComponent);
